import { useIntl } from 'react-intl';

import GiftCardContextProvider from '@/components/giftCardV2/GiftCardContextProvider';
import GiftCardPurchase from '@/components/giftCardV2/GiftCardPurchase';
import Layout from '@/components/layout/LayoutWrapper';
import StripeElementsProvider from '@/components/purchase/StripeElementsProvider';
import messages from '@/messages/messages';

const GiftCardPage = () => {
	const { formatMessage } = useIntl();

	return (
		<Layout pageName="configure_gift_card" title={`Calm - ${formatMessage(messages.giftCardPageTitle)}`}>
			<StripeElementsProvider isStripeNext currency="usd">
				<GiftCardContextProvider>
					<GiftCardPurchase />
				</GiftCardContextProvider>
			</StripeElementsProvider>
		</Layout>
	);
};

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';
export default GiftCardPage;
